import { SvgIcon, SvgIconProps } from "@mui/material";

export const AiStarIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 8 8">
    <path
      fill="currentColor"
      d="M3.79167 8C3.63542 7.10417 3 5.97917 1.79167 5.07292C1.19792 4.625 0.59375 4.33333 0 4.20833V3.77083C1.17708 3.48958 2.33333 2.69792 3.07292 1.625C3.44792 1.08333 3.6875 0.552083 3.79167 0H4.22917C4.40625 1.05208 5.21875 2.21875 6.32292 3C6.86458 3.38542 7.42708 3.64583 8 3.77083V4.20833C6.84375 4.44792 5.5 5.47917 4.83333 6.53125C4.5 7.0625 4.30208 7.55208 4.22917 8H3.79167Z"
    />
  </SvgIcon>
);
